import { Link } from 'react-router-dom';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import {
  BannerCarouselDesktop,
  BannerCarouselMobile,
} from '~/components/isolated/Carousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useGlobal } from '~/hooks/useGlobal';

import { createCategoryUrl } from '../shared/utils';

import styles from './BannerCategoryBlock.module.scss';
import { BannerCategoryBlockProps } from './interfaces';

const BannerCategoryBlock = ({ banners }: BannerCategoryBlockProps) => {
  const { isMobile } = useGlobal();
  const { handleClickCategory } = useCategoryAnalytics();

  if (!banners || banners.length === 0) {
    return null;
  }

  const items = banners.map(({ src, scrThumb, alt, linkId }) => ({
    id: linkId,
    node: (
      <Link
        data-link={`banner-${linkId}`}
        className={styles.link}
        onClick={handleClickCategory(linkId)}
        to={createCategoryUrl({ id: linkId })}
      >
        <CloudflareResponseImage
          alt={alt}
          className={styles.image}
          loading="lazy"
          src={isMobile ? scrThumb || src : src}
          srcSetParams={defaultSrcSetParams}
        />
      </Link>
    ),
  }));

  // Always 2 slides per view on desktop
  const slidesPerView = 2;
  // Show arrows only if more than 2 banners
  const showArrows = banners.length > 2;

  return (
    <div className={styles.container}>
      {isMobile ? (
        <BannerCarouselMobile items={items} />
      ) : (
        <BannerCarouselDesktop
          items={items}
          slidesPerView={slidesPerView}
          showArrows={showArrows}
        />
      )}
    </div>
  );
};

export default BannerCategoryBlock;
